import { PlusCircleOutlined } from '@ant-design/icons'
import { UploadDownloadButtons } from '@components/_SiteWide/UploadStatus/UploadDownloadButtons'
import { SpecificTimeOrNowFilter } from '@components/SupplyManagement/components/SpecificTimeOrNowFilter'
import type { DateControlOptions, SupplyDirectoryHeaderFilters } from '@components/SupplyManagement/types'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import type { GridApi } from 'ag-grid-community'
import type React from 'react'

type OutageActionButtonsProps = {
  headerFilters: SupplyDirectoryHeaderFilters
  setHeaderFilters: (filter: SupplyDirectoryHeaderFilters) => void
  handleEditOutage: (outageData?: Gravitate.SupplyOutage) => void
  gridAPIRef: React.MutableRefObject<GridApi>
}

export function OutageActionButtons({
  headerFilters,
  setHeaderFilters,
  handleEditOutage,
  gridAPIRef,
}: OutageActionButtonsProps) {
  function updateFilters(time: string, dateControl: DateControlOptions) {
    setHeaderFilters({
      ...headerFilters,
      filter: {
        ...headerFilters.filter,
        as_of: time,
      },
      dateControl: dateControl,
    })
  }
  return (
    <Horizontal gap={8} alignItems='center'>
      <UploadDownloadButtons
        excelOptions={[
          {
            title: 'Download Outages',
            onClick: () =>
              gridAPIRef.current.exportDataAsExcel({
                sheetName: 'Supply Outages',
                fileName: 'supply_outages.xlsx',
                allColumns: true,
              }),
          },
        ]}
      />
      <SpecificTimeOrNowFilter
        filters={{ as_of: headerFilters.filter.as_of, date_control: headerFilters.dateControl }}
        onChange={updateFilters}
      />
      <GraviButton
        buttonText='Create Outage'
        success
        onClick={() => handleEditOutage(null)}
        icon={<PlusCircleOutlined />}
      />
    </Horizontal>
  )
}
